import type { ViewComponent } from "@frui.ts/views";
import type ChargeDetailInfoViewModel from "viewModels/callCenter/search/charges/chargeDetail/chargeDetailInfoViewModel";
import { observer } from "mobx-react-lite";
import { Col, Form } from "react-bootstrap";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import React from "react";
import OrderSourceTypeGroup from "./orderSourceTypeGroup";
import { emptyValueFormatter } from "./index";
import { FormLabelWithTooltip } from "controls/formLabelWithTooltip";

const KioskOrderSection: ViewComponent<ChargeDetailInfoViewModel> = observer(({ vm }) => {
  const order = vm.item.chargeOrderDetail;
  return (
    <>
      <OrderSourceTypeGroup vm={vm} />
      <Form.Group as={Col} md={6} xl={4}>
        <Form.Label>{vm.translateSubAttribute("kioskOrderDetailResponse", "kioskIdent")}</Form.Label>
        <FakeInput target={order.kioskOrderDetail} property="kioskIdent" />
      </Form.Group>
      <Form.Group as={Col} md={6} xl={4}>
        <Form.Label>{vm.translateSubAttribute("payGatePayment", "terminalId")}</Form.Label>
        <FakeInput target={order.kioskOrderDetail?.payGatePayment} property="terminalId" valueFormatter={emptyValueFormatter} />
      </Form.Group>
      <Form.Group as={Col} md={12}>
        <Form.Label>{vm.translateSubAttribute("kioskOrderDetailResponse", "name")}</Form.Label>
        <FakeInput target={order.kioskOrderDetail} property="name" />
      </Form.Group>
      <Form.Group as={Col} md={12}>
        <Form.Label>{vm.translateSubAttribute("payGatePayment", "cardNumber")}</Form.Label>
        <FakeInput target={order.kioskOrderDetail?.payGatePayment} property="cardNumber" valueFormatter={emptyValueFormatter} />
      </Form.Group>
      <Form.Group as={Col} md={6}>
        <FormLabelWithTooltip tooltipText={vm.translate("terminalSequenceIdentTooltip")}>
          {vm.translateSubAttribute("payGatePayment", "terminalSequenceIdent")}
        </FormLabelWithTooltip>
        <FakeInput
          target={order.kioskOrderDetail?.payGatePayment}
          property="terminalSequenceIdent"
          valueFormatter={emptyValueFormatter}
        />
      </Form.Group>
      <Form.Group as={Col} md={6}>
        <Form.Label>{vm.translateSubAttribute("payGatePayment", "authCode")}</Form.Label>
        <FakeInput target={order.kioskOrderDetail?.payGatePayment} property="authCode" valueFormatter={emptyValueFormatter} />
      </Form.Group>
    </>
  );
});

export default KioskOrderSection;
